// import React, { Component, useEffect } from "react";
// import { connect } from "react-redux";
// import Aux from "../../../../../../hoc/_Aux";
// import DEMO from "../../../../../../store/constant";
// import * as actionTypes from "../../../../../../store/actions";
// import NavIcon from "./../NavIcon";
// import NavBadge from "./../NavBadge";
// import NavItem from "../NavItem";
// import { NavLink } from "react-router-dom";
// import LoopNavCollapse from "./index";

// class NavCollapse extends Component {
//   componentDidMount() {
//     const currentIndex = document.location.pathname
//       .toString()
//       .split("/")
//       .findIndex((id) => id === this.props.collapse.id);
//     console.log(document.location.pathname);
//     if (currentIndex > -1) {
//       this.props.onCollapseToggle(this.props.collapse.id, this.props.type);
//     }
//   }

//   render() {
//     const { isOpen, isTrigger } = this.props;
//     console.log(this.props.collapse.children);

//     let navItems = "";
//     if (this.props.collapse.children) {
//       const collapses = this.props.collapse.children;
//       navItems = Object.keys(collapses).map((item) => {
//         item = collapses[item];
//         switch (item.type) {
//           case "collapse":
//             return <LoopNavCollapse key={item.id} collapse={item} type="sub" />;
//           case "item":
//             return (
//               <NavItem layout={this.props.layout} key={item.id} item={item} />
//             );
//           default:
//             return false;
//         }
//       });
//     }

//     let itemTitle = this.props.collapse.title;
//     if (this.props.collapse.icon) {
//       itemTitle = (
//         //<br/> 태그 추가
//         <span
//           className="pcoded-mtext "
//           style={{ whiteSpace: "pre-wrap", padding: "0 5px 0 0" }}
//         >
//           {this.props.collapse.title}
//         </span>
//       );
//     }

//     let navLinkClass = ["nav-link"];

//     let navItemClass = ["nav-item", "pcoded-hasmenu"];
//     const openIndex = isOpen.findIndex((id) => id === this.props.collapse.id);
//     if (openIndex > -1) {
//       navItemClass = [...navItemClass, "active"];
//       if (this.props.layout !== "horizontal") {
//         navLinkClass = [...navLinkClass, "active"];
//       }
//     }

//     const triggerIndex = isTrigger.findIndex(
//       (id) => id === this.props.collapse.id
//     );
//     if (triggerIndex > -1) {
//       navItemClass = [...navItemClass, "pcoded-trigger"];
//     }

//     const currentIndex = document.location.pathname
//       .toString()
//       .split("/")
//       .findIndex((id) => id === this.props.collapse.id);
//     if (currentIndex > -1) {
//       navItemClass = [...navItemClass, "active"];
//       if (this.props.layout !== "horizontal") {
//         navLinkClass = [...navLinkClass, "active"];
//       }
//     }

//     const subContent = (
//       <Aux>
//         {/* nav #!원인 */}
//         {/* <a
//           href={this.props.collapse.url}
//           className={navLinkClass.join(" ")}
//           onClick={() =>
//             this.props.onCollapseToggle(this.props.collapse.id, this.props.type)
//           }
//         >
//           <NavIcon items={this.props.collapse} />
//           {itemTitle}
//           <NavBadge layout={this.props.layout} items={this.props.collapse} />
//         </a> */}
//         <NavLink
//           to={this.props.collapse.url}
//           className={navLinkClass.join(" ")}
//           onClick={() =>
//             this.props.onCollapseToggle(this.props.collapse.id, this.props.type)
//           }
//         >
//           <NavIcon items={this.props.collapse} />
//           {itemTitle}
//           <NavBadge layout={this.props.layout} items={this.props.collapse} />
//         </NavLink>
//         <ul className="pcoded-submenu">{navItems}</ul>
//       </Aux>
//     );

//     // nav toggle 이벤트 pcoded-trigger
//     let mainContent = "";
//     if (this.props.layout === "horizontal") {
//       mainContent = (
//         <li
//           className={navItemClass.join(" ")}
//           onMouseLeave={() =>
//             this.props.onNavCollapseLeave(
//               this.props.collapse.id,
//               this.props.type
//             )
//           }
//           onMouseEnter={() =>
//             this.props.onCollapseToggle(this.props.collapse.id, this.props.type)
//           }
//         >
//           {subContent}
//         </li>
//       );
//     } else {
//       //mainContent = <li className={navItemClass.join(" ")}>{subContent}</li>;
//       mainContent = (
//         <li className={navLinkClass.join(" ")}>
//           {/* 새로고침 원인 */}
//           {/* <a
//             href={this.props.collapse.url}
//             onClick={() =>
//               this.props.onCollapseToggle(
//                 this.props.collapse.id,
//                 this.props.type
//               )
//             }
//           >
//             <span>xxxx</span>
//             <NavIcon items={this.props.collapse} />
//             {itemTitle}
//             <NavBadge layout={this.props.layout} items={this.props.collapse} />
//           </a> */}
//           <NavLink
//             to={this.props.collapse.url}
//             onClick={() =>
//               this.props.onCollapseToggle(
//                 this.props.collapse.id,
//                 this.props.type
//               )
//             }
//           >
//             <NavIcon items={this.props.collapse} />
//             {itemTitle}
//             <NavBadge layout={this.props.layout} items={this.props.collapse} />
//           </NavLink>
//           <ul className="pcoded-submenu">{navItems}</ul>
//         </li>
//       );
//     }

//     return <Aux>{mainContent}</Aux>;
//   }
// }

// const mapStateToProps = (state) => {
//   return {
//     layout: state.layout,
//     isOpen: state.isOpen,
//     isTrigger: state.isTrigger,
//   };
// };

// const mapDispatchToProps = (dispatch) => {
//   return {
//     onCollapseToggle: (id, type) =>
//       dispatch({
//         type: actionTypes.COLLAPSE_TOGGLE,
//         menu: { id: id, type: type },
//       }),
//     onNavCollapseLeave: (id, type) =>
//       dispatch({
//         type: actionTypes.NAV_COLLAPSE_LEAVE,
//         menu: { id: id, type: type },
//       }),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(NavCollapse);

import React, { useEffect } from "react";
import { connect } from "react-redux";
import Aux from "../../../../../../hoc/_Aux";
import * as actionTypes from "../../../../../../store/actions";
import NavIcon from "./../NavIcon";
import NavBadge from "./../NavBadge";
import NavItem from "../NavItem";
import { NavLink } from "react-router-dom";
import LoopNavCollapse from "./index";

const NavCollapse = (props) => {
  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split("/")
      .findIndex((id) => id === props.collapse.id);

    if (currentIndex > -1) {
      props.onCollapseToggle(props.collapse.id, props.type);
    }
  }, [props.collapse.id, props.type, props.onCollapseToggle]);

  const { isOpen, isTrigger } = props;

  let navItems = "";
  if (props.collapse.children) {
    const collapses = props.collapse.children;
    navItems = Object.keys(collapses).map((item) => {
      item = collapses[item];
      switch (item.type) {
        case "collapse":
          return <LoopNavCollapse key={item.id} collapse={item} type="sub" />;
        case "item":
          return <NavItem layout={props.layout} key={item.id} item={item} />;
        default:
          return false;
      }
    });
  }

  let itemTitle = props.collapse.title;
  if (props.collapse.icon) {
    itemTitle = (
      <span
        className="pcoded-mtext "
        style={{ whiteSpace: "pre-wrap", padding: "0 5px 0 0" }}
      >
        {props.collapse.title}
      </span>
    );
  }

  let navLinkClass = ["nav-link"];
  let navItemClass = ["nav-item", "pcoded-hasmenu"];
  const openIndex = isOpen.findIndex((id) => id === props.collapse.id);
  // console.log("props.collapse", props.collapse);
  // console.log("props.collapse.id", props.collapse.id);
  // console.log("isOpen", isOpen);
  // console.log("openIndex", openIndex);

  if (openIndex > -1) {
    navItemClass = [...navItemClass, "active"];
    if (props.layout !== "horizontal") {
      navLinkClass = [...navLinkClass, "active"];
    }
  }

  const triggerIndex = isTrigger.findIndex((id) => id === props.collapse.id);

  if (triggerIndex > -1) {
    navItemClass = [...navItemClass, "pcoded-trigger"];
  }

  const currentIndex = document.location.pathname
    .toString()
    .split("/")
    .findIndex((id) => id === props.collapse.id);

  if (currentIndex > -1) {
    navItemClass = [...navItemClass, "active"];
    if (props.layout !== "horizontal") {
      navLinkClass = [...navLinkClass, "active"];
    }
  }

  const subContent = (
    <Aux>
      <NavLink
        to={props.collapse.url}
        className={navLinkClass.join(" ")}
        onClick={() => props.onCollapseToggle(props.collapse.id, props.type)}
      >
        <NavIcon items={props.collapse} />
        {itemTitle}
        <NavBadge layout={props.layout} items={props.collapse} />
      </NavLink>
      <ul className="pcoded-submenu">{navItems}</ul>
    </Aux>
  );

  let mainContent = "";
  if (props.layout === "horizontal") {
    mainContent = (
      <li
        className={navItemClass.join(" ")}
        onMouseLeave={() =>
          props.onNavCollapseLeave(props.collapse.id, props.type)
        }
        onMouseEnter={() =>
          props.onCollapseToggle(props.collapse.id, props.type)
        }
      >
        {subContent}
      </li>
    );
  } else {
    mainContent = (
      <li className={navLinkClass.join(" ")}>
        <NavLink
          to={props.collapse.url}
          onClick={() => props.onCollapseToggle(props.collapse.id, props.type)}
        >
          <NavIcon items={props.collapse} />
          {itemTitle}
          <NavBadge layout={props.layout} items={props.collapse} />
        </NavLink>
        <ul className="pcoded-submenu">{navItems}</ul>
      </li>
    );
  }

  return <Aux>{mainContent}</Aux>;
};

const mapStateToProps = (state) => {
  return {
    layout: state.layout,
    isOpen: state.isOpen,
    isTrigger: state.isTrigger,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCollapseToggle: (id, type) =>
      dispatch({
        type: actionTypes.COLLAPSE_TOGGLE,
        menu: { id: id, type: type },
      }),
    onNavCollapseLeave: (id, type) =>
      dispatch({
        type: actionTypes.NAV_COLLAPSE_LEAVE,
        menu: { id: id, type: type },
      }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NavCollapse);
